import * as api from '@apis/admin-user';
import { AdminUser } from '@models/auth';
import { useQuery } from '@tanstack/react-query';
import { Button, Modal, Table } from 'antd';
import { ColumnsType } from 'antd/es/table';
import React, { useState } from 'react';

const PAGE_SIZE = 20;
interface UserListModalProps {
  commissionRateId?: string;
  open?: boolean;
  onClose?: () => void;
}

export const UserListModal: React.FC<UserListModalProps> = (props) => {
  const [searchQuery, setSearchQuery] = useState({
    page: 0,
    size: PAGE_SIZE,
  });

  const { commissionRateId } = props;
  const usersQuery = useQuery({
    queryKey: [`user-${commissionRateId}`, JSON.stringify(searchQuery)],
    queryFn: () => api.searchUsers({ ...searchQuery, commissionRateId }),
  });

  const users = usersQuery.data?.data?.contents || [];

  const TABLE_COLUMNS: ColumnsType<AdminUser> = [
    {
      title: 'ID',
      render: (record: AdminUser) => {
        return record?._id;
      },
    },
    {
      title: '역할',
      align: 'center',
      render: (record: AdminUser) => {
        return record?.roles.join(' / ');
      },
    },
    {
      title: '이름',
      align: 'center',
      render: (record: AdminUser) => {
        return `${record?.profile?.name || '-'}\n(${record.profile?.nickname || '-'})`;
      },
    },
  ];

  return (
    <Modal
      styles={{ footer: { height: '44px' } }}
      open={props.open}
      footer={
        <div style={{ width: '100%' }}>
          <Button
            style={{
              width: 120,
            }}
            onClick={props.onClose}>
            닫기
          </Button>
        </div>
      }
      onCancel={props.onClose}>
      <div>
        <div style={{ fontSize: '16px', fontWeight: 'bold' }}>유저 목록</div>
        <Table
          columns={TABLE_COLUMNS}
          scroll={{ x: 'max-content', y: 'calc(100dvh - 280px)' }}
          style={{ whiteSpace: 'pre-wrap' }}
          rowKey={(record) => record?._id}
          dataSource={users}
          pagination={{
            current: (usersQuery.data?.data?.page || 0) + 1,
            pageSize: usersQuery.data?.data?.size || 20,
            total: usersQuery.data?.data?.total || 0,
          }}
          loading={usersQuery.isLoading}
          onChange={(e) => {
            setSearchQuery({ page: (e.current || 2) - 1, size: e.pageSize || 20 });
          }}
        />
      </div>
    </Modal>
  );
};

export default UserListModal;
